import { createFileRoute } from "@tanstack/react-router";
import { FreeTestPage } from "@/components/free-test/FreeTestPage";
import { freeTestHead } from "@/components/free-test/free-test-head";

// Бесплатный мини-тест (ru) — тот же тест из 4 вопросов, что на главной.
export const Route = createFileRoute("/besplatnyy-test-proforientatsii")({
  head: () => freeTestHead("ru"),
  component: () => <FreeTestPage lang="ru" />,
});
